module.exports = __webpack_public_path__ + "img/DE01661.ebb3fdce.png";